import type { WasmBinaryName } from "../shared"

export type TaskOutcome<Result> = { data: Result; transfer?: ArrayBuffer[] }

export type TaskContext<Wasm extends WasmBinaryName> = {
    wasm: Record<Wasm, WebAssembly.Module>
    signal: AbortSignal
}

export type Task<Args, Result, Wasm extends WasmBinaryName> = {
    name: string
    wasm: readonly Wasm[]
    run(args: Args, context: TaskContext<Wasm>): Promise<TaskOutcome<Result>>
}

export type AnyTask = {
    name: string
    wasm: readonly WasmBinaryName[]
    run(args: unknown, context: TaskContext<never>): Promise<TaskOutcome<unknown>>
}

export type TaskArgs<T extends AnyTask> =
    T extends Task<infer Args, infer _R, infer _W> ? Args : never

export type TaskResult<T extends AnyTask> =
    T extends Task<infer _A, infer Result, infer _W> ? Result : never

export const defineTask = <Args, Result, Wasm extends WasmBinaryName = never>({
    wasm = [],
    name,
    run,
}: {
    name: string
    wasm?: readonly Wasm[]
    run: (args: Args, context: TaskContext<Wasm>) => Promise<TaskOutcome<Result>>
}) => ({ name, run, wasm })
